// Large picking: what happens after the "How full is your york?" answer
// and after a york drop-off. Pure, so the decision is testable without
// mounting the 2,800-line ActiveWaveScreen.
//
// The rule (Alex, 2026-10-05): an EMPTY york is the decision point. A
// Large picker should fill their york before changing pick type — a
// quarter-full york dropped off costs the same trip as a full one — but
// must not stay on Large all day either when the Pick Queue is now
// suggesting Sorting. The Pick Queue (and its Suggested card) is only
// seen from the queue, so:
//
//   • part-full (1–3)  → scan for the next Large order, as before. The
//                        york gets filled; the server offers only orders
//                        that fit the space reported.
//   • full (4)         → the drop-off screen, as before; after the
//                        confirm the picker goes back to the Pick Queue
//                        (previously: straight to the next-order scan,
//                        which kept them on Large by default).
//   • empty (0)        → back to the Pick Queue. An empty york after a
//                        completed order means it has just been dropped,
//                        so whatever is suggested now — Large or Sorting
//                        — is the right next pick.
//
// "Nothing fits" (part-full but no queued order fits the space) still
// goes through the drop-off screen, and therefore also ends at the
// queue. No new UI: the queue, the Suggested card and the Large
// starting-location scan are the existing screens.

import type { YorkQuarters } from "./YorkFillPrompt";

export type AfterYorkAnswer = "queue" | "next-order" | "york-drop";

export const afterYorkAnswer = (quarters: YorkQuarters): AfterYorkAnswer => {
    if (quarters === 4) return "york-drop";
    if (quarters === 0) return "queue";
    return "next-order";
};

// After a confirmed drop-off the york is empty — same decision point.
export const afterYorkDrop = (): AfterYorkAnswer => "queue";
